"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReanimatedBottomSheetModal = void 0;
const react_native_1 = require("react-native");
const ReanimatedBottomSheetContext_1 = require("./ReanimatedBottomSheetContext");
exports.useReanimatedBottomSheetModal = () => {
    const { dispatch } = ReanimatedBottomSheetContext_1.useReanimatedBottomSheet();
    const onPresentHandler = () => {
        if (react_native_1.Platform.OS === 'android') {
            react_native_1.StatusBar.setTranslucent(true);
            react_native_1.StatusBar.setBackgroundColor('transparent');
            react_native_1.StatusBar.setBarStyle('dark-content');
        }
    };
    const onDismissHandler = (andriodStatusBarStyle = {
        isTranslucent: true,
        backgroundColor: '#fff',
        barStyle: 'dark-content',
    }) => {
        dispatch({
            type: ReanimatedBottomSheetContext_1.RESET,
        });
        if (react_native_1.Platform.OS === 'android') {
            react_native_1.StatusBar.setTranslucent(andriodStatusBarStyle.isTranslucent);
            react_native_1.StatusBar.setBackgroundColor(andriodStatusBarStyle.backgroundColor);
            react_native_1.StatusBar.setBarStyle(andriodStatusBarStyle.barStyle);
        }
    };
    return {
        reanimatedBottomOnPresentHandler: onPresentHandler,
        reanimatedBottomOnDismissHandler: onDismissHandler,
    };
};
